<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Filter Catalog </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="filter.search"
              outlined
              label="Search"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.categoryId"
              :items="categories"
              item-text="name"
              item-value="id"
              label="Category"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.industryId"
              :items="industries"
              item-text="name"
              item-value="id"
              label="Industry"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.topicId"
              :items="topics"
              item-text="name"
              item-value="id"
              label="Topic"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.designGroupId"
              :items="design_groups"
              item-text="name"
              item-value="id"
              label="Design Group"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.hasDescription"
              :items="yesNoItems"
              outlined
              label="Has Description?"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.hasLongContent"
              :items="yesNoItems"
              outlined
              label="Has Long Content?"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.hasQuestions"
              :items="yesNoItems"
              outlined
              label="Has Questions?"
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Done
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
  name: 'ContentCatalogFilter',
  data() {
    return {
      valid: false,
      drawer: false,
      saving: false,
      filter: {},
      yesNoItems: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ]
    };
  },

  computed: {
    ...mapGetters({
      categories: 'lookup/categories',
      industries: 'lookup/industries',
      topics: 'lookup/topics',
      design_groups: 'lookup/design_groups'
    })
  },
  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.FILTER_CATALOG_PAGE_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.FILTER_CATALOG_PAGE_SHOW, () => {
      this.filter = Object.assign({}, cloneDeep(this.$store.getters['catalogPages/filter']));
      this.drawer = true;
    });
  },
  methods: {
    save() {
      this.saving = true;
      Promise.all([this.$store.dispatch('catalogPages/setFilter', cloneDeep(this.filter))])
        .then(() => {
          this.drawer = false;
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
